export class ErrorData {
    data?: Data;
    code?: string;
    message?: string;
}

export class Data {
    statusCode?: string;
    message?: '';
}